import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { Switch } from "react-router-dom";
import NavbarTop from "../components/navbar/NavbarTop";
import NavbarVertical from "../components/navbar/NavbarVertical";
import Footer from "../components/footer/Footer";
import loadable from "@loadable/component";
import AppContext from "../context/Context";
import { getPageName } from "../helpers/utils";

const DashboardRoutes = loadable(() => import("./DashboardRoutes"));

const DashboardLayout = ({ location }) => {
  const {
    isFluid,
    navbarStyle,
    isNavbarVerticalCollapsed,
    setIsNavbarVerticalCollapsed,
  } = useContext(AppContext);

  const isKanban = getPageName("kanban");

  useEffect(() => {
    DashboardRoutes.preload();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const toggleSidebar = () => {
    setIsNavbarVerticalCollapsed(!isNavbarVerticalCollapsed);
  };

  return (
    <div
      className={`${isFluid || isKanban ? "container-fluid" : "container"} ${
        isNavbarVerticalCollapsed ? "sidebar-collapsed" : ""
      }`}
    >
      <NavbarVertical
        navbarStyle={navbarStyle}
        isCollapsed={isNavbarVerticalCollapsed}
      />
      <div
        className={`content ${
          isNavbarVerticalCollapsed ? "content-sidebar-collapsed" : ""
        }`}
      >
        <NavbarTop toggleSidebar={toggleSidebar} />
        <div className="flex-grow-1">
          <Switch>
            <DashboardRoutes />
          </Switch>
        </div>
        <Footer />
      </div>
    </div>
  );
};

DashboardLayout.propTypes = { location: PropTypes.object.isRequired };

export default DashboardLayout;
